module.exports = __webpack_public_path__ + "static/media/lmd-build.fd5acf87.jpg";